import * as React from 'react'; 
import styled from 'styled-components';

interface IProps {
  /** @ignore */
  className?: string;
  /** @ignore */
  children?: React.ReactNode;
}

const PaneHeadingBase = (props: IProps) =>
  <div className={props.className}>
    {props.children}
  </div>

const PaneHeadingStyled = styled(PaneHeadingBase)`
  position: relative;
  box-sizing: border-box;
  height: 80px;
  background-color: ${p => p.theme.colors.primary[5]};
  padding: 0px 30px 0 30px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
`

const PaneHeading = (props: IProps) => <PaneHeadingStyled {...props}/>

export { PaneHeading }
